module["exports"] = [
  "Пан",
  "Пані"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/uk/name/prefix.js
// module id = 2173
// module chunks = 0